import React, { useEffect, useRef } from "react";

type FefoDialogProps = {
  isOpen: boolean;
  title: string;
  description?: string;
  onClose: () => void;
  /** Botões do rodapé. */
  actions: React.ReactNode;
  wide?: boolean;
  children: React.ReactNode;
};

/** Moldura dos diálogos do Controle de Bebidas: fecha com Esc e com clique fora. */
const FefoDialog: React.FC<FefoDialogProps> = ({ isOpen, title, description, onClose, actions, wide, children }) => {
  const dialogRef = useRef<HTMLDivElement>(null);
  // Em ref para o efeito rodar só na abertura: o foco inicial não pode voltar
  // ao primeiro campo a cada render enquanto a pessoa digita.
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCloseRef.current();
    };
    document.addEventListener("keydown", onKey);
    dialogRef.current?.querySelector<HTMLElement>("input, select, button")?.focus();
    return () => document.removeEventListener("keydown", onKey);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="ecoDialog__overlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        ref={dialogRef}
        className={`ecoDialog fefoDialog${wide ? " fefoDialog--wide" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="fefo-dialog-title"
      >
        <div>
          <h2 id="fefo-dialog-title" className="ecoDialog__title">
            {title}
          </h2>
          {description ? <p className="ecoDialog__text fefoDialog__desc">{description}</p> : null}
        </div>
        <div className="fefoDialog__body">{children}</div>
        <div className="ecoDialog__actions">{actions}</div>
      </div>
    </div>
  );
};

export default FefoDialog;
